import React from 'react';
import ReactDOM from 'react-dom/client';
import './globalPageStyles';
import App from './App';
import './index.css';
import './mobile-overrides.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
